import React from "react";
interface BtnProps {
  children: React.ReactNode;
  handleClick?: () => void;
  className?: string;
  disabled?: boolean;
}
export default function FormButtonDisable(props: BtnProps) {
  const { children, handleClick, className,disabled } = props;
  // const buttonClasses = `${className} ${disabled ? "disabled" : ""}`; disabled={disabled}
  return (
    <div>
      <button onClick={handleClick} className={className} >
        {children}
      </button>
    </div>
  );
}
